export enum CertificationStatus {
  COMPLETE = "complete",
  IN_PROGRESS = "inProgress",
  NOT_IN_PROGRESS = "notInProgress",
}
export const BULK_LICENSES_THRESHOLD = 1;
export const BRAND_SD = "sd";
export const BRAND_ADBW = "adbw";
export const BRAND_BOOMERS = "boomers";